export default ".response-div {\n  border: 1px solid grey;\n  padding: 10px 20px !important;\n  margin: 10px;\n}";